import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeVacancy } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodeVacancyTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeVacancy>;
}

const NodeVacancyTeaser: React.FC<NodeVacancyTeaserProps> = ({ entity }) => {
  const vacancy = entity.toJS();

  const minHours = vacancy.field_hours_minimum?.[0]?.value || '';
  const maxHours = vacancy.field_hours_maximum?.[0]?.value || '';
  const hoursPerWeek = minHours && maxHours ? `${minHours}-${maxHours}` : minHours || maxHours;

  const formatPublishDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('nl-NL', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
  };

  const formattedPublishDate = formatPublishDate(vacancy.field_publish_date[0].value);

  return (
    <CoreLink href={vacancy.field_link[0].uri} className="VacancyTeaser">
      <div className="VacancyTeaser__container">
        <div className="VacancyTeaser__container__title">
          <span>
            {vacancy.title[0].value}
          </span>
          <i className="icon icon-variant-4 icon-arrow-top-right" />
        </div>
        <div className="VacancyTeaser__container__info">
          {(minHours || maxHours) && (
            <div className="VacancyTeaser__container__info__section">
              <i className="icon icon-clock" />
              <span>
                {hoursPerWeek} uur
              </span>
            </div>
          )}
          {vacancy.field_education_level && (
            <div className="VacancyTeaser__container__info__section">
              <i className="icon icon-education_cap" />
              <span>
                {vacancy.field_education_level?.[0]?.value || ''}
              </span>
            </div>
          )}
          <div className="VacancyTeaser__container__info__section">
            <i className="icon icon-calendar" />
            <span>
              {formattedPublishDate}
            </span>
          </div>
        </div>
      </div>
    </CoreLink>
  );
};

export default NodeVacancyTeaser;
